export default {
  color: {
    primary: '#00d8ff',
    white: '#fff',
  },
};
